import React, { Component, Fragment } from "react";
import { ICDBPageProps } from "../../../../utils/ICDBPageProps";
import AdminRolloverForm from "../../../../models/rollover/AdminRolloverForm";
import { Checkbox, CommandBarButton, DatePicker, TextField } from "office-ui-fabric-react";
import LoadingCard from "../../../LoadingCard";
import moment from 'moment';
import AdminSchoolMenu from "../../../AdminSchoolMenu";
import SchoolPageTitle from "../../../SchoolPageTitle";
import {Link} from "react-router-dom";

interface AdminRolloverFormPageProps extends ICDBPageProps {
    tenantId: string;
    schoolCode: string;
    academicYear: string;
}

interface AdminRolloverFormPageState {
    loading: boolean;
    saving: boolean;
    rolloverForm?: AdminRolloverForm;
}

export default class AdminRolloverFormPage extends Component<AdminRolloverFormPageProps, AdminRolloverFormPageState> {

    constructor(props: AdminRolloverFormPageProps) {
        super(props);

        this.state = {
            loading: false,
            saving: false
        }
    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode && this.props.academicYear) {
            await this.loadForm();
        }
    }

    async loadForm() {
        try {
            this.setState({ loading: true });
            const rolloverForm = await this.props.apiService.getAdminRolloverForm(this.props.tenantId, this.props.schoolCode, this.props.academicYear);
            this.setState({ loading: false, rolloverForm });
        }
        catch (ex) {
            this.props.messageBar.error(ex.message);
            this.setState({ loading: false });
        }
    }

    async saveForm() {
        if (this.state.rolloverForm !== undefined && this.state.saving === false) {
            try {
                this.setState({ saving: true });
                await this.props.apiService.saveAdminRolloverForm(this.state.rolloverForm);
                this.setState({ saving: false });
                this.props.messageBar.success("Rollover form saved");
            }
            catch (ex) {
                this.props.messageBar.error(ex.message);
                this.setState({ saving: false });
            }
        }
    }

    private buildForm(): JSX.Element {
        if (this.state.loading || this.state.rolloverForm === undefined) {
            return <LoadingCard />;
        }
        else {
            return <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Admin Rollover Form</span>

                        <Link to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/rollover/form/${this.props.academicYear}`}>
                            <CommandBarButton
                                iconProps={{ iconName: "view" }}
                                text="View customer page"
                                disabled={this.state.saving}
                                onClick={() => {}} />
                        </Link>
                        
                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            disabled={this.state.saving}
                            onClick={() => this.saveForm()} />
                    </div>
                    <div className={"card__content"}>

                        <Checkbox
                            className="card__input"
                            label="Customer has confirmed"
                            checked={this.state.rolloverForm.customerConfirmed}
                            disabled={true}
                            onChange={(_, checked?: boolean) => this.setState({
                                rolloverForm: {
                                    ...this.state.rolloverForm!,
                                    customerConfirmed: checked ?? false
                                }
                            })} />

                        <TextField
                            className="card__input"
                            label="Academic year"
                            value={this.state.rolloverForm.academicYear}
                            disabled={true} />

                        <DatePicker
                            className="card__input"
                            label={"Rollover date"}
                            value={moment(this.state.rolloverForm.rolloverDate).toDate()}
                            disabled={this.state.saving}
                            minDate={moment().toDate()}
                            onSelectDate={(selectedDate?: Date | undefined | null) => this.setState({
                                rolloverForm: {
                                    ...this.state.rolloverForm!,
                                    rolloverDate: moment(selectedDate!).utc(true).format()
                                }
                            })}
                            placeholder="Select a date..." />

                        <DatePicker
                            className="card__input"
                            label={"Add student memberships date"}
                            value={moment(this.state.rolloverForm.addStudentMembershipsDate).toDate()}
                            disabled={this.state.saving}
                            minDate={moment().toDate()}
                            onSelectDate={(selectedDate?: Date | undefined | null) => this.setState({
                                rolloverForm: {
                                    ...this.state.rolloverForm!,
                                    addStudentMembershipsDate: moment(selectedDate!).utc(true).format()
                                }
                            })}
                            placeholder="Select a date..." />

                        <TextField
                            className="card__input"
                            label="Admin notes"
                            value={this.state.rolloverForm.adminNotes}
                            disabled={this.state.saving}
                            multiline
                            rows={3}
                            onChange={(_, value?: string) => this.setState({
                                rolloverForm: {
                                    ...this.state.rolloverForm!,
                                    adminNotes: value ?? ""
                                }
                            })} />

                    </div>
                </div>
            </Fragment>
        }
    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Rollover form" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    {this.buildForm()}
                </div>
            </Fragment>
        );
    }
}
